import React, { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
const Layout = lazy(() => import("@/components/Layout"));
const Login = lazy(() => import("@/pages/Login"));
const AcceptInvitation = lazy(() => import("@/pages/AcceptInvitation"));
const ContactWidgetDemo = lazy(() => import("@/pages/ContactWidgetDemo"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const Leads = lazy(() => import("@/pages/Leads"));
const LeadDetail = lazy(() => import("@/pages/LeadDetail"));
const NewLead = lazy(() => import("@/pages/NewLead"));
const Automations = lazy(() => import("@/pages/Automations"));
const Widget = lazy(() => import("@/pages/Widget"));
const PublicEmbed = lazy(() => import("@/pages/PublicEmbed"));
const ContactStats = lazy(() => import("@/pages/ContactStats"));
const CalendarPage = lazy(() => import("@/pages/Calendar"));
const Settings = lazy(() => import("@/pages/Settings"));
const BillingStart = lazy(() => import("@/pages/BillingStart"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const Archives = lazy(() => import("@/pages/Archives"));
const Integrations = lazy(() => import("@/pages/Integrations"));
const IntegrationDetail = lazy(() => import("@/pages/IntegrationDetail"));
const AgentsList = lazy(() => import("@/pages/Agents").then((module) => ({ default: module.AgentsList })));
const AgentDetail = lazy(() => import("@/pages/Agents").then((module) => ({ default: module.AgentDetail })));
import { Toaster } from "sonner";

function RedirectAgentToCircuit() {
  const { agentId } = useParams();
  return <Navigate to={`/circuits/${agentId}`} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-right" theme="light" duration={2000} />
          <Suspense fallback={null}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/invitation/:token" element={<AcceptInvitation />} />
            <Route path="/demo/contact-widget" element={<ContactWidgetDemo />} />
            <Route path="/embed/:mode" element={<PublicEmbed />} />
            <Route path="/c/:agentId" element={<PublicEmbed />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route path="/billing/start" element={<BillingStart />} />

            <Route element={<Layout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/leads/new" element={<NewLead />} />
              <Route path="/leads/:id" element={<LeadDetail />} />
              <Route path="/archives" element={<Archives />} />
              <Route path="/agent" element={<Navigate to="/circuits" replace />} />
              <Route path="/agents" element={<Navigate to="/circuits" replace />} />
              <Route path="/agents/:agentId" element={<RedirectAgentToCircuit />} />
              <Route path="/circuits" element={<AgentsList />} />
              <Route path="/circuits/:agentId" element={<AgentDetail />} />
              <Route path="/automations" element={<Automations />} />
              <Route path="/widget" element={<Widget />} />
              <Route path="/contact-page" element={<Navigate to="/widget?mode=contact" replace />} />
              <Route path="/calendrier" element={<CalendarPage />} />
              <Route path="/stats" element={<ContactStats />} />
              <Route path="/rdv" element={<Navigate to="/calendrier" replace />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/integrations/:connectionId" element={<IntegrationDetail />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          </Suspense>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
